// 智能入职
export const salaryRouter = [
  {
    path: '/salary/salaryDiscount',
    name: 'salaryDiscount',
    component: () => import('../views/salary/salaryDiscount')
  },
]